{
  "version": "1.0",
  "builder": "design",

  "apiEndpoints": {
    "// shapeBuilder": "Legacy design template store. Unused while readApi is set.",
    "templatesApi": "/api/shape-builder-components",

    "// save": "Where Save writes the design with its layers. Platform host; absolute URL wins.",
    "saveApi": "/spriced/platform/api/dashboard-layers",

    "// read": "Saved designs: GET for the list, GET <readApi>/<dashboardId> for one.",
    "readApi": "/spriced/platform/api/dashboard-layers",

    "// platform": "Published dashboards. Blank uses the shared dashboard service.",
    "publishApi": "",
    "publishEntity": "dashboard_layouts",

    "// projects": "Groups dashboards. Falls back to localStorage when absent.",
    "projectsApi": "/api/dvm/self-service/design-projects"
  },

  "storageKeys": {
    "designs": "dvm.selfService.designs",
    "draft": "dvm.selfService.designDraft",
    "projects": "dvm.selfService.designProjects"
  },

  "publish": {
    "builderTag": "design"
  }
}
